/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class UploadUploadController {
    public static $inject = [
        '$scope',
        '$state',
        'upload',
        'toaster',
        'bsLoadingOverlayService'
    ];

    public fileInfo: any = {};
    public fileName;

    constructor(
        private $scope: INavbarScope,
        private $state: angular.ui.IStateService,
        private upload: any,
        private toaster: toaster.IToasterService,
        private bsLoadingOverlayService: IBsLoadingService) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    }

    public doUpload(): void {
        this.bsLoadingOverlayService.start({ referenceId: 'document_upload' });

        this.$scope.$emit('$EL', 'files.upload');

        this.upload({
            url: '/api/uploads',
            method: 'POST',
            data: {file: this.fileInfo.file}
        }).then(
            (response) => {
                this.bsLoadingOverlayService.stop({ referenceId: 'document_upload' });
                this.toaster.pop('success', 'upload complete', '');
                this.$state.go('^');
            },
            (response) => {
                this.bsLoadingOverlayService.stop({ referenceId: 'document_upload' });
                this.toaster.pop('error', 'upload failed', '');
            }
        );
    }
}

angular.module('beneple.upload')
    .controller('UploadUploadController', UploadUploadController);



// WEBPACK FOOTER //
// ./frontend/scripts/upload/controllers/upload-upload.controller.ts